function getStatus(status, path) {
  var paths = Object.keys(status);
  if (typeof path === "string") {
    var nestedPaths = paths.filter(function (statusPath) {
      return statusPath.startsWith("".concat(path, "."));
    });
    return status[path] || nestedPaths.some(function (statusPath) {
      return status[statusPath];
    }) || false;
  }
  return paths.some(function (statusPath) {
    return status[statusPath];
  });
}
export { getStatus };